import { createApi } from '@reduxjs/toolkit/query/react'
import { url } from 'inspector'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const CateringAPI = createApi({
  reducerPath: 'CateringAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Catering'],
  endpoints: builder => ({
    postCaterings: builder.mutation({
      query: body => ({
        url: `/api/Caterings`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Catering'],
    }),
    postCombo: builder.mutation({
      query: body => ({
        method: 'POST',
        url: `/api/Caterings/${body.id}/combos`,
        headers: authHeaderAPI(),
        body: body.data,
      }),
      invalidatesTags: ['Catering'],
    }),
    getCatering: builder.query({
      query: params => ({
        url: `/api/Caterings`,
        method: 'GET',
        params,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Catering'],
    }),
    deleteCatering: builder.mutation({
      query: id => ({
        method: 'DELETE',
        url: `/api/Caterings/${id}`,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Catering'],
    }),
    getCateringById: builder.query({
      query: id => ({
        method: 'GET',
        url: `/api/Caterings/${id}`,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Catering'],
    }),
    getComboById: builder.query({
      query: id => ({
        method: 'GET',
        url: `/api/Caterings/${id}/combos`,
        headers: authHeaderAPI(),
      }),
      providesTags: ['Catering'],
    }),
    updateCatering: builder.mutation({
      query: body => ({
        method: 'PUT',
        url: `/api/Caterings/${body.Id}`,
        headers: authHeaderAPI(),
        body,
      }),
      invalidatesTags: ['Catering'],
    }),
    updateCombo: builder.mutation({
      query: body => ({
        method: 'PUT',
        url: `/api/Caterings/${body.id}/combos`,
        headers: authHeaderAPI(),
        body: body.data,
      }),
      invalidatesTags: ['Catering'],
    }),
  }),
})
export const {
  useDeleteCateringMutation,
  useGetCateringByIdQuery,
  useGetCateringQuery,
  usePostCateringsMutation,
  usePostComboMutation,
  useUpdateCateringMutation,
  useUpdateComboMutation,
  useGetComboByIdQuery,
} = CateringAPI
